import React, { useEffect, useRef, useState } from "react";
import { toFarsiNumber } from "../../helper/helper";
import Input from "../shared/Form/Input";
import { useForm } from "react-hook-form";
import CircleLoading from "../shared/CircleLoading";
import { postData } from "../../services/API";
import { Toast } from "primereact/toast";

const EpisodeQsTab = ({ data, number, setQuestions }) => {
  const [openTab, setOpenTab] = useState(false);
  const { getValues, register, setValue } = useForm();
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    data.answers?.length > 0 && setValue("answer", data.answers[0].answer);
  }, []);

  const submitAnswerHandler = () => {
    setLoading(true);

    postData("/acd/lesson/question-answer", {
      question_id: data.id,
      episode_id: data.episode_id,
      answer: getValues("answer"),
    })
      .then((res) => {
        ref.current.show({
          severity: "success",
          summary: "با موفقیت انجام شد",
          detail: "پاسخ شما ذخیره شد",
          life: 3500,
        });
        setQuestions(res.data);
        setLoading(false);
      })
      .catch((err) => {
        ref.current.show({
          severity: "error",
          summary: "خطا",
          detail: "ذخیره پاسخ با خطا مواجه شد",
          life: 3500,
        });

        setLoading(false);
      });
  };

  return (
    <>
      <Toast ref={ref} />

      <div
        className={`w-full ring-1 ${
          openTab
            ? "h-fit max-h-[6000px] pb-5 ring-yellow-700"
            : "max-h-14 ring-gray-800"
        } transition-all duration-300 relative px-5 overflow-hidden flex flex-col gap-4 rounded-xl bg-[#222]`}
      >
        <div
          onClick={() => setOpenTab(!openTab)}
          className="w-full cursor-pointer flex min-h-[56px] justify-between items-center text-gray-300"
        >
          <h2
            className={`${
              openTab ? "text-yellow-700" : "text-gray-300"
            } text-sm sm:text-base`}
          >
            {`${toFarsiNumber(number)}. ${data.question}`}
          </h2>

          <div
            className={` p-2 rounded-xl flex items-center gap-3 z-10 left-3 top-[14px] outline-none border-none`}
          >
            {data?.answers?.length > 0 && (
              <div className="size-7 bg-green-600 bg-opacity-15 flex justify-center items-center text-green-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m4.5 12.75 6 6 9-13.5"
                  />
                </svg>
              </div>
            )}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class={`${
                openTab ? "rotate-180 stroke-yellow-700" : "stroke-gray-300"
              } duration-300 w-5 h-5 `}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <Input
            label={"پاسخ شما"}
            placeHolder={"پاسخ خود را بنویسید"}
            register={{ ...register("answer") }}
            className={"!h-44 !bg-gray-800 !ring-0"}
          />

          <button
            onClick={submitAnswerHandler}
            className="w-full h-11 rounded-xl flex justify-center items-center text-white bg-green-600"
          >
            {loading ? <CircleLoading /> : <span>ذخیره پاسخ</span>}
          </button>
        </div>
      </div>
    </>
  );
};

export default EpisodeQsTab;
